import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { style: { "text-align": "left", "white-space": "pre-wrap" } };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { key: 0 };
import useContract from '@/composables/useContract';
import { statusOptions, jobSectionOptions } from '@/composables/composablesConsts';
import MessageModal from '@/components/message/MessageModal.vue';
import MessageCompanyUserSelecterModal from '@/components/message/MessageCompanyUserSelecterModal.vue';
import AdminNoteModal from '@/components/adminNote/AdminNoteModal.vue';
import { NoteableType } from '@/models/adminNote';
import { ref, onMounted } from 'vue';
import { formatShortDate } from '@/utils/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    setup(__props) {
        const { contracts, fetchData, generateFormFromQuery, form, totalPages } = useContract();
        // 検索ボタン: 条件を変えたときは 1 ページ目から表示する
        // （2 ページ目のまま検索すると、該当件数がそれ以下のときに 0 件に見えるため）
        const search = () => {
            form.value.page = 1;
            fetchData();
        };
        // ページ番号を押したとき（Vuetify 3 の v-pagination は input ではなく update:modelValue を発生させる）
        const onPageChange = (page) => {
            form.value.page = page;
            fetchData();
        };
        onMounted(() => {
            generateFormFromQuery();
            fetchData();
        });
        const selectStatusOptions = [
            // { text: '全て', value: -1 },
            ...statusOptions
        ];
        const selectJobSectionOptions = [
            { text: '全て', value: '' },
            ...jobSectionOptions
        ];
        // MessageModal周りの設定
        const showMessage = ref(false);
        const fromUserId = ref(0);
        const toUserId = ref(0);
        const initMessageModal = (_fromUserId, _toUserId) => {
            fromUserId.value = _fromUserId;
            toUserId.value = _toUserId;
            showMessage.value = true;
        };
        // AdminNoteModal周りの設定
        const showUserNote = ref(false);
        const selectedUserContractId = ref(0);
        const initUserNote = (contractId) => {
            selectedUserContractId.value = contractId;
            showUserNote.value = true;
        };
        const showSystemNote = ref(false);
        const selectedSystemContractId = ref(0);
        const initSystemNote = (contractId) => {
            selectedSystemContractId.value = contractId;
            showSystemNote.value = true;
        };
        // MessageCompanyUserSelecterModal周りの設定
        const showCompanyUserSelecter = ref(false);
        const companyId = ref(0);
        const initCompanyUserSelecter = (_companyId, _fromUserId) => {
            companyId.value = _companyId;
            fromUserId.value = _fromUserId;
            showCompanyUserSelecter.value = true;
        };
        const selectedCompanyUser = (userId) => {
            initMessageModal(fromUserId.value, userId);
        };
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _component_router_link = _resolveComponent("router-link");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_pagination = _resolveComponent("v-pagination");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createElementVNode("h2", null, "契約一覧", -1)
                                ])),
                                _: 1,
                                __: [9]
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_form, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "3" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_select, {
                                                modelValue: _unref(form).jobSections,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).jobSections) = $event)),
                                                items: selectJobSectionOptions,
                                                label: "案件種別",
                                                "item-title": "text",
                                                "item-value": "value"
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "3" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                modelValue: _unref(form).companyName,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).companyName) = $event)),
                                                label: "企業名"
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "3" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                modelValue: _unref(form).plannerName,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).plannerName) = $event)),
                                                label: "プランナー"
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "3" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                modelValue: _unref(form).jobTitle,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).jobTitle) = $event)),
                                                label: "案件名"
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "3" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_autocomplete, {
                                                modelValue: _unref(form).statuses,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).statuses) = $event)),
                                                items: selectStatusOptions,
                                                label: "ステータス",
                                                "item-title": "text",
                                                "item-value": "value",
                                                multiple: "",
                                                chips: "",
                                                clearable: ""
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "3" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, { onClick: search }, {
                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                    _createTextVNode("検索")
                                                ])),
                                                _: 1,
                                                __: [10]
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "3" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, { to: "/contract/create" }, {
                                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                    _createTextVNode("新規作成")
                                                ])),
                                                _: 1,
                                                __: [11]
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_table, {
                                style: { "width": "100%" },
                                density: "compact"
                            }, {
                                default: _withCtx(() => [
                                    _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", { rowspan: "2" }, "ID"),
                                            _createElementVNode("th", { rowspan: "2" }, "プランナー名"),
                                            _createElementVNode("th", { rowspan: "2" }, "案件名"),
                                            _createElementVNode("th", { rowspan: "2" }, "企業名"),
                                            _createElementVNode("th", { rowspan: "2" }, "ステータス"),
                                            _createElementVNode("th", { colspan: "3" }, "メッセージ閲覧"),
                                            _createElementVNode("th", { rowspan: "2" }, "変更履歴"),
                                            _createElementVNode("th", { rowspan: "2" }, "メモ")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contracts), (contract) => {
                                            return (_openBlock(), _createElementBlock("tr", null, [
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/contract/${contract.id}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(contract.id), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/planners/${contract.plannerId}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(contract.plannerName), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                _createElementVNode("td", null, _toDisplayString(contract.jobTitle) + " (" + _toDisplayString(contract.jobSections) + ")", 1),
                                                _createElementVNode("td", null, _toDisplayString(contract.companyName), 1),
                                                _createElementVNode("td", null, _toDisplayString(contract.statusText), 1),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("a", {
                                                        onClick: ($event) => (initMessageModal(0, contract.plannerUserId))
                                                    }, [
                                                        _createVNode(_component_v_icon, null, {
                                                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                                _createTextVNode("mdi-face-woman-outline")
                                                            ])),
                                                            _: 1,
                                                            __: [12]
                                                        })
                                                    ], 8, _hoisted_1)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("a", {
                                                        onClick: ($event) => (initCompanyUserSelecter(contract.companyId, 0))
                                                    }, [
                                                        _createVNode(_component_v_icon, null, {
                                                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                                _createTextVNode("mdi-church-outline")
                                                            ])),
                                                            _: 1,
                                                            __: [13]
                                                        })
                                                    ], 8, _hoisted_2)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("a", {
                                                        onClick: ($event) => (initCompanyUserSelecter(contract.companyId, contract.plannerUserId))
                                                    }, [
                                                        _createVNode(_component_v_icon, null, {
                                                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                                _createTextVNode("mdi-swap-horizontal")
                                                            ])),
                                                            _: 1,
                                                            __: [14]
                                                        })
                                                    ], 8, _hoisted_3)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("a", {
                                                        onClick: ($event) => (initSystemNote(contract.id))
                                                    }, [
                                                        (contract.systemNote == '')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                                                            : _createCommentVNode("", true),
                                                        _createTextVNode(" " + _toDisplayString(_unref(formatShortDate)(contract.systemNoteCreated)) + " ", 1),
                                                        _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                                                        _createTextVNode(" " + _toDisplayString(contract.systemNote.slice(0, 40)), 1)
                                                    ], 8, _hoisted_4)
                                                ]),
                                                _createElementVNode("td", _hoisted_6, [
                                                    _createElementVNode("a", {
                                                        onClick: ($event) => (initUserNote(contract.id))
                                                    }, [
                                                        (contract.userNote == '')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                                                _createVNode(_component_v_icon, null, {
                                                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                                        _createTextVNode("mdi-pencil-plus-outline")
                                                                    ])),
                                                                    _: 1,
                                                                    __: [16]
                                                                })
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _createTextVNode(" " + _toDisplayString(contract.userNote.slice(0, 40)), 1)
                                                    ], 8, _hoisted_7)
                                                ])
                                            ]));
                                        }), 256))
                                    ])
                                ]),
                                _: 1,
                                __: [17]
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_pagination, {
                                        "model-value": _unref(form).page,
                                        length: _unref(totalPages),
                                        "onUpdate:modelValue": onPageChange
                                    }, null, 8, ["model-value", "length"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    (showMessage.value)
                        ? (_openBlock(), _createBlock(MessageModal, {
                            key: 0,
                            "from-user-id": fromUserId.value,
                            "to-user-id": toUserId.value,
                            onClose: _cache[5] || (_cache[5] = ($event) => (showMessage.value = false))
                        }, null, 8, ["from-user-id", "to-user-id"]))
                        : _createCommentVNode("", true),
                    (showCompanyUserSelecter.value)
                        ? (_openBlock(), _createBlock(MessageCompanyUserSelecterModal, {
                            key: 1,
                            "company-id": companyId.value,
                            "from-user-id": fromUserId.value,
                            onClose: _cache[6] || (_cache[6] = ($event) => (showCompanyUserSelecter.value = false)),
                            onSelectCompanyUser: selectedCompanyUser
                        }, null, 8, ["company-id", "from-user-id"]))
                        : _createCommentVNode("", true),
                    (showUserNote.value)
                        ? (_openBlock(), _createBlock(AdminNoteModal, {
                            key: 2,
                            "noteable-id": selectedUserContractId.value,
                            "noteable-type": _unref(NoteableType).ContractMode,
                            mode: 'user',
                            onClose: _cache[7] || (_cache[7] = ($event) => (showUserNote.value = false))
                        }, null, 8, ["noteable-id", "noteable-type"]))
                        : _createCommentVNode("", true),
                    (showSystemNote.value)
                        ? (_openBlock(), _createBlock(AdminNoteModal, {
                            key: 3,
                            "noteable-id": selectedSystemContractId.value,
                            "noteable-type": _unref(NoteableType).ContractMode,
                            mode: 'system',
                            onClose: _cache[8] || (_cache[8] = ($event) => (showSystemNote.value = false))
                        }, null, 8, ["noteable-id", "noteable-type"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
